import { Component, Vue } from 'vue-property-decorator';
import ArticleText from '@/components/ArticleText/ArticleText.vue';
import { ArticleTextModuleViewModel } from './ArticleTextModule.types';

const ArticleTextModuleProps = Vue.extend(ArticleTextModuleViewModel);

@Component({
  components: {
    ArticleText,
  },
})
export default class ArticleTextModule extends ArticleTextModuleProps {}
